module.exports = __webpack_public_path__ + "static/media/gray_01.8781a7a1.jpg";